// Retail Leasing rotating taglines — tone: exciting yet professional, for brand owners & retail BD heads
export const RETAIL_QUOTES = [
  "Brand-Fit Retail. Curated for Real Roll-Outs.",
  "Where India's Most Loved Brands Find Their Next Address.",
  "Sourcing Frontage. Saving Quarters.",
  "Designed for Retail Roll-Out Teams.",
  "From Mandate to Possession — Without the Phone Tree.",
  "Quietly Powering India's Most Active Retail Brands.",
  "Brand-Fit Spaces, Without the Scouting Hangover.",
  "Footfall, Frontage, Possession — All in One Brief.",
  "Pre-Sourced for Retail Business Development.",
  "Real Estate That Behaves Like a Product.",
  "Built for Brands Who Plan in Quarters, Not Hopes.",
  "Premium High-Streets, Curated Catchments, Clear Timelines.",
  "From Brand Brief to Possession — One Curated Pipeline.",
  "We Bring Spaces. You Bring the Brand.",
  "Spaces So Right, Your BD Team Will Smile.",
  "Frontage You Can Photograph. Footfall You Can Forecast.",
  "Curated for Brand Roll-Out Velocity.",
  "Where Retail BD Teams Find Their Calm.",
  "Premium Storefronts, Sourced With Intent.",
  "Lease Documents That Read Like Lease Documents.",
  "We Move Brands the Way Logistics Moves Boxes.",
  "Real Estate at Retail-BD Speed.",
  "The Curated Side of Commercial Leasing.",
  "Brand Roll-Outs, Powered by a Curated Pipeline.",
  "Retail Real Estate, But With a Calendar.",
  "From Shortlist to Hand-Over Without the Drama.",
  "Curated. Contracted. Cash-Flowing.",
  "Possession Dates You Can Plan a Launch Around.",
  "Sourcing Catchments. Curating Outcomes.",
  "Retail Real Estate, Without the Real Estate Lifestyle.",
  "Built for Brands Who Roll Out in Calendar Months.",
  "Frontage Filtered for Brand Fit.",
  "We Curate the Where. You Focus on the What.",
  "A Retail Pipeline India's Top Brands Quietly Trust.",
  "Possession is the New ROI.",
  "We Bring You the Frontage. The Footfall is a Bonus.",
  "Retail Leasing, With a Possession Calendar Attached.",
  "Less Phone Calls. More Store Openings.",
  "Where Lease Documents Don't Need a Translator.",
  "Premium Real Estate. Without the Premium Process.",
  "Curated Spaces for Curated Brands.",
  "From Pitch Deck to Possession — Without a Scavenger Hunt.",
  "Frontage Sourced. Footfall Implied. Brand Welcomed.",
  "We Curate Real Estate Like Brands Curate Collections.",
  "Spaces with a Calendar, Not a Brochure.",
  "Designed for Brand BD. Documented for Legal.",
  "Built for Brands Who Read the Lease Before the Brochure.",
  "Where India's Best-Loved Brands Find Their Next Address.",
  "We Curate. We Verify. We Hand Over Keys.",
  "Curated Retail Real Estate for Brand-Roll-Out Teams.",
  "From Brand Brief to Hand-Over. Without the Phone Tree.",
  "Possession Dates That Survive Boardroom Reviews.",
  "Curated Catchments. Premium Frontages. Period.",
  "Sourcing Frontage With BD Discipline.",
  "We Bring You Curated Pipeline. You Bring Your Brand.",
  "Quietly Curated. Loudly Successful.",
  "Real Estate Built for Brand-Side Velocity.",
  "Premium Frontage, Sourced With Discipline.",
  "Where Frontage Meets Footfall, Curated.",
  "We Don't Have Listings. We Have a Pipeline.",
  "Built for Retail BD Teams Who Plan Six Quarters Out.",
  "From Brand-Side Brief to Brand-Open Day.",
  "We Source. We Curate. You Sign.",
  "Brand-Fit Frontage. Curated Catchments. Possession Calendars.",
  "Retail Real Estate, Quietly Engineered for Brands.",
  "Curated Pipeline. Brand-Side Velocity. Calm Possession.",
  "Premium Frontages. Curated Catchments. Possession Dates.",
  "Storefronts Curated for Retail-BD Excellence.",
  "Where Brand BD Teams Find Their Quietest Wins.",
  "Frontage With a Calendar. Catchments With Conviction.",
  "Built Quietly. Roll-Outs Loudly.",
  "We Curate Frontage. You Curate the Brand.",
  "A Curated Pipeline for India's Retail-Roll-Out Era.",
  "Frontage. Footfall. Possession. Curated.",
  "Brand-Fit Real Estate. Quietly Sourced.",
  "We Source. We Document. We Hand Over.",
  "Curated Frontage for Retail-Roll-Out Teams.",
  "Where Brand-BD Briefs Become Possession Dates.",
  "Frontage Engineered for Brand-Roll-Out Calendars.",
  "Curated Catchments. Calm Documents. Confirmed Possession.",
  "We Curate the Address. You Curate the Brand.",
];

export const RETAIL_NOUN = "Curated, brand-fit retail real estate — high streets, premium malls and emerging catchments across India.";
